"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var _componentUtils = require("../../common/componentUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatBannerCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$mobileTitle = _ref.mobileTitle,
    mobileTitle = _ref$mobileTitle === void 0 ? '' : _ref$mobileTitle,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$img = _ref.img,
    img = _ref$img === void 0 ? '' : _ref$img,
    _ref$mobileImg = _ref.mobileImg,
    mobileImg = _ref$mobileImg === void 0 ? '' : _ref$mobileImg,
    _ref$video = _ref.video,
    video = _ref$video === void 0 ? '' : _ref$video,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? '' : _ref$bg,
    _ref$btnText = _ref.btnText,
    btnText = _ref$btnText === void 0 ? '' : _ref$btnText,
    _ref$btnHref = _ref.btnHref,
    btnHref = _ref$btnHref === void 0 ? '' : _ref$btnHref,
    _ref$weakBtn = _ref.weakBtn,
    weakBtn = _ref$weakBtn === void 0 ? [] : _ref$weakBtn,
    _ref$links = _ref.links,
    links = _ref$links === void 0 ? [] : _ref$links,
    _ref$linksOverflowTex = _ref.linksOverflowText,
    linksOverflowText = _ref$linksOverflowTex === void 0 ? '' : _ref$linksOverflowTex,
    _ref$videoCard = _ref.videoCard,
    videoCard = _ref$videoCard === void 0 ? null : _ref$videoCard,
    _ref$videoBtn = _ref.videoBtn,
    videoBtn = _ref$videoBtn === void 0 ? '' : _ref$videoBtn,
    _ref$activityList = _ref.activityList,
    activityList = _ref$activityList === void 0 ? [] : _ref$activityList,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list;
  const handledList = list === null || list === void 0 ? void 0 : list.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      img = _ref2.img,
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text,
      _ref2$tooltip = _ref2.tooltip,
      tooltip = _ref2$tooltip === void 0 ? '' : _ref2$tooltip;
    return {
      text,
      tooltip,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url
    };
  });
  // 转化Banner主按钮
  const handleBtn = () => {
    const btnExtendProps = {
      'report-event': 'click_heroBanner_button_primary',
      'report-ext1': btnText || '',
      'report-ext2': btnHref || '',
      target: '_blank'
    };
    return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
      type: 'primary',
      icon: true,
      href: btnHref
    }, btnExtendProps), btnText);
  };

  // 转化Banner次按钮
  const handleWeakBtn = weakBtn.map((item, index) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$btns = item.btns,
      btns = _item$btns === void 0 ? [] : _item$btns;
    const handleBtns = btns.map((item, key) => {
      const text = item.text,
        href = item.href;
      const btnExtendProps = {
        'report-event': `click_heroBanner_button_weak`,
        'report-ext1': index,
        'report-ext2': key,
        'report-ext3': text || '',
        target: '_blank'
      };
      return _objectSpread({
        text,
        href
      }, btnExtendProps);
    });
    return {
      text,
      btns: handleBtns
    };
  });

  // 转化文字链
  const handleLinkList = links.map((item, index) => {
    const text = item.text,
      href = item.href;
    const linkExtendProps = {
      'report-event': `click_heroBanner_link`,
      'report-ext1': index,
      'report-ext2': text || '',
      'report-ext3': href || '',
      target: '_blank'
    };
    return _objectSpread({
      text,
      href
    }, linkExtendProps);
  });

  // 转化卡片类视频
  const handleVideoCard = () => {
    const _videoCard$text = videoCard.text,
      text = _videoCard$text === void 0 ? '' : _videoCard$text,
      _videoCard$duration = videoCard.duration,
      duration = _videoCard$duration === void 0 ? '' : _videoCard$duration,
      _videoCard$img = videoCard.img,
      img = _videoCard$img === void 0 ? '' : _videoCard$img,
      _videoCard$mobileImg = videoCard.mobileImg,
      mobileImg = _videoCard$mobileImg === void 0 ? '' : _videoCard$mobileImg,
      _videoCard$video = videoCard.video,
      video = _videoCard$video === void 0 ? '' : _videoCard$video;
    return {
      text,
      duration,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      mobileImg: (0, _componentUtils.doComponentsUploadEvent)(mobileImg || '').url,
      video: (0, _componentUtils.doComponentsUploadEvent)(video || '').url
    };
  };
  // 转化运营位
  const handleActivityList = activityList.map((item, index) => {
    const _item$tagType = item.tagType,
      tagType = _item$tagType === void 0 ? 'new' : _item$tagType,
      tagText = item.tagText,
      title = item.title,
      desc = item.desc,
      btnText = item.btnText,
      btnHref = item.btnHref,
      img = item.img,
      fileTitle = item.fileTitle;
    const btnExtendProps = {
      'report-event': 'click_heroBanner_activity_item',
      'report-ext1': index,
      'report-ext2': btnText || '',
      'report-ext3': btnHref || '',
      target: '_blank'
    };
    return {
      tag: tagText ? {
        type: tagType,
        text: tagText
      } : null,
      title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: title
      }) : '',
      desc,
      btns: btnText && btnHref ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        type: 'weak',
        href: btnHref
      }, btnExtendProps), btnText) : null,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      fileTitle: fileTitle ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: title
      }) : ''
    };
  });
  const btnExtendProps = {
    'report-event': 'click_heroBanner_button',
    'report-ext1': btnText || '',
    'report-ext2': btnHref || '',
    target: '_blank'
  };
  let btnComm = /*#__PURE__*/React.createElement(React.Fragment, null);
  if (btnText && btnHref) {
    btnComm = /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
      type: 'primary',
      icon: true,
      href: btnHref
    }, btnExtendProps), btnText);
  }
  return {
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    mobileTitle: mobileTitle ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: mobileTitle
    }) : '',
    desc: desc,
    img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
    mobileImg: (0, _componentUtils.doComponentsUploadEvent)(mobileImg || '').url,
    video: (0, _componentUtils.doComponentsUploadEvent)(video || '').url,
    bg: bg || '',
    btns: btnText && btnHref ? handleBtn() : null,
    weakBtn: !!weakBtn.length ? handleWeakBtn : null,
    links: !!links.length ? handleLinkList : null,
    linksOverflowText,
    videoCard: videoCard !== null && videoCard !== void 0 && videoCard.img && videoCard !== null && videoCard !== void 0 && videoCard.video ? handleVideoCard() : null,
    videoBtn: (0, _componentUtils.doComponentsUploadEvent)(videoBtn || '').url,
    activityList: !!activityList.length ? handleActivityList : null,
    list: handledList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const heroData = formatBannerCommon(data, {
      domains
    });
    console.log(heroData);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      className: "gems-materials-qci__newUI-banner"
    }, (0, _reportUtil.reportShow)(['show_newUI_Banner', componentKey, (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Hero, Object.assign({}, heroData, {
      type: 'recommend'
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}